import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Form, FormControl } from 'react-bootstrap';
import { Multiselect } from 'multiselect-react-dropdown';
import * as queryString from 'query-string';
import {
  getAccountOwnersList,
  getLeads,
  setTopOffset,
  addSearchLeads,
} from '../../redux/reduxActions/leadActions';
import LeadItem from './LeadItem';
import { ReactComponent as DownArrow } from '../../assets/svg/down-arrow.svg';
import { ReactComponent as Close } from '../../assets/svg/close.svg';
import SelectedFilter from '../componentsUI/SelectedFilter';
import { clearFiltersData, setFiltersToStorage, setSearchToStorage } from '../utils';
import Paginator from '../componentsUI/Paginator';
import FolderAndEstimationPopup from './FolderAndEstimationPopup';
import RedminePopup from './RedminePopup';
import { ReactComponent as SortUp } from '../../assets/svg/sortUp.svg';
import { ReactComponent as SortDown } from '../../assets/svg/sortDown.svg';
import {compose} from "redux";
const LeadsList = (props) => {
  const {
    actionType,
    leads,
    leadsFromRedminePopup,
    workType,
    priorities,
    funnelStatuses,
    funnelType,
    workTech,
    responsible,
    offset,
    history,
    location,
  } = props;
  const [counter, setCounter] = useState(1);
  const [selectedPriorities, setSelectedPriorities] = useState([]);
  const [selectedWorkTypes, setWorkTypes] = useState([]);
  const [selectedWorkTechs, setWorkTechs] = useState([]);
  const [selectedFunnelTypes, setSelectedFunnelTypes] = useState([]);
  const [selectedFunnelStatuses, setSelectedFunnelStatuses] = useState([]);
  const [selectedResponsible, setSelectedResponsible] = useState([]);
  const [leadType, setLeadType] = useState('2');
  const [leadsList, setLeadsList] = useState([]);
  const [onRemove, setOnRemove] = useState(false);
  const [isDropdownListOpen, setIsDropdownListOpen] = useState(false);
  const [leadsPerPage, setLeadsPerPage] = useState('20');
  const [page, setPage] = useState(1);
  const setSortOptions = [{ typed: 'sortByCreated', title: 'Time created', order: 'asc' }, { typed: 'sortByCreated', title: ' Time created', order: 'desc' }, { typed: 'sortByUpdated', title: 'Time updated', order: 'asc' }, { typed: 'sortByUpdated', title: 'Time updated', order: 'desc' }];
  const sortDefault = {updated: false, typed: 'sortByUpdated', title: 'Time updated', order: 'desc' };
  const [sortSave, setSortSave] = useState(localStorage.getItem('FilterLeads') ? getSortStorage() : sortDefault);
  // console.log(leadsFromRedminePopup);
  // console.log(props);
  useEffect(() => {
    if (offset || offset === 0) {
      window.scrollTo(0, offset);
    }
  }, [leads, offset]);
  useEffect(() => {
    props.getAccountOwnersList();
  }, []);
  useEffect(() => {
    if (sortSave.updated) {
      setFilters(leadsPerPage, 1);
    }
  }, [sortSave]);
  useEffect(() => {
    if (onRemove) {
      // console.log('second');
      setFilters(leadsPerPage, 1);
      setOnRemove(false);
    }
  }, [onRemove]);

  function buildArrayString(search, data) {
    // console.log(search);
    // console.log(data)
    return data.map((item) => `&${search}=${item.id}`).join('');
  }

  function buildStringSort(data) {
    // console.log(data);
    // '&sortByUpdated=true&order=asc'
    const routeSortString = `&${data.typed}=true&order=${data.order}`;
    return routeSortString;
  }

  const getQuery = () => {
    if (location.search) {
      return location.search;
    }
    if (localStorage.getItem('FilterLeads')) {
      // console.log(localStorage
      //   .getItem('FilterLeads')
      //   .substring(1, localStorage.getItem('FilterLeads').length - 1));
      return localStorage
        .getItem('FilterLeads')
        .substring(1, localStorage.getItem('FilterLeads').length - 1);
    }
    return undefined;
  };
  function getSortStorage() {
    const parsed = queryString.parse(localStorage.getItem('FilterLeads').slice(1));
    const result = setSortOptions.find(item => parsed[item.typed] && item.order === parsed.order) || sortDefault;
    result.updated = false;
    return result;
  }

  function setStateByUrlData(backData, search, setter) {
    const parsed = queryString.parse(getQuery());
    // console.log(parsed);
    if (backData && parsed[search]) {
      // console.log( parsed[search]);
      let array_operation = null;
      if(parsed[search]>9){
        array_operation = Array(parsed[search]);
      }else{
        array_operation = [...parsed[search]];
      }
      // console.log(array_operation);
    let data = array_operation.map((item) => backData.find((inner) => parseInt(item, 10) === parseInt(inner.id, 10)));
      // console.log(data);
      data = data.filter((item) => item !== undefined);
      // console.log(data);
      setter(data);
      return buildArrayString(search, data);
    }
    return '';
  }

  // function buildFilterFromLocalStorage(data, setter, search) {
  // 	setter(data);
  // 	return buildArrayString(search, data);
  // }
  useEffect(() => {
    // console.log(actionType,
    //   workType,
    //   priorities,
    //   funnelStatuses,
    //   funnelType,
    //   workTech,
    //   responsible,
    //   offset,
    //   history,
    //   location, 'actionType, workType, priorities, funnelStatuses,  funnelType, workTech, responsible, offset, history, location');
    // console.log(getQuery());
    const parsed = queryString.parse(getQuery());
    setLeadsPerPage(parsed.leadsPerPage || '20');
    const leadsPerPageInner = parsed.leadsPerPage || '20';
    setPage(parseInt(parsed.page, 10) || 1);
    const pageInner = parsed.page ? parseInt(parsed.page, 10) : 1;
    delete parsed.leadsPerPage;
    delete parsed.page;
    delete parsed.offset;
    // console.log(parsed);
    if (
      funnelStatuses.length !== 0
            && workTech.length !== 0
            && workType.length !== 0
            && funnelType.length !== 0
            && priorities.length !== 0
            && responsible.length !== 0
    ) {
      const objectivePriorities = Object.entries(priorities).map((key) => ({
        id: key[0],
        name: key[1],
      })) || [];
      const objectiveResp = Object.entries(responsible).map((key) => ({
        id: key[0],
        name: key[1],
      })) || [];
      setLeadType(parsed.status || leadType);
      const requestStr = `
              ${setStateByUrlData() || ''}
		      ${setStateByUrlData(workType, 'workType[]', setWorkTypes) || ''}
		      ${
  setStateByUrlData(
    funnelType,
    'funnelType[]',
    setSelectedFunnelTypes,
  ) || ''
}
		      ${setStateByUrlData(workTech, 'workTech[]', setWorkTechs) || ''}
		      ${
  setStateByUrlData(
    funnelStatuses,
    'funnelStatus[]',
    setSelectedFunnelStatuses,
  ) || ''
}
		      ${
  setStateByUrlData(
    objectiveResp,
    'responsible[]',
    setSelectedResponsible,
  ) || ''
}
		     ${
  setStateByUrlData(
    objectivePriorities,
    'priority[]',
    setSelectedPriorities,
  ) || ''
}
		      ${parsed.status ? `&status=${parsed.status}` : ''}`.replace(/\s/g, '');
      const sortQuery = parsed.order !== undefined ? `&${parsed.sortByUpdated ? 'sortByUpdated' : 'sortByCreated'}=true&order=${parsed.order}` : `&${sortSave.typed}=true&order=${sortSave.order}`;
      // console.log(sortQuery);
      // console.log(parsed);
      // console.log(requestStr);
      // console.log(pageInner);
      // console.log(leadsPerPageInner);
      props.getLeads(
        `page=${pageInner}&limit=${leadsPerPageInner}${requestStr}${sortQuery}`,
      );
    }
    window.scrollTo(0, offset);
  }, [
    actionType,
    workType,
    priorities,
    funnelStatuses,
    funnelType,
    workTech,
    responsible,
    offset,
    history,
    location,
  ]);
  useEffect(() => {
    if (actionType) {
      setLeadsList(
        leads.data.filter((item) => item.funnel_status === actionType),
      );
    } else if (sessionStorage.getItem('lastSearch')) {
      setLeadsList(JSON.parse(sessionStorage.getItem('lastSearch')));
    }  else {
      setLeadsList(leads.data);
    }
  }, [leads]);

  function filterLeads(value) {
    const searchWord = value;
    /* const newlistOfLeads=leadsList.map((el) => {
          const ItemNow = el.title;
          if(ItemNow.includes(value)){
            return el.title;
          }
        });
        console.log(newlistOfLeads); */
    const leadsListFiltered = leadsList.map((item) => {
      let titleFilter = false;
      let commentFilter = false;
      if (item.title) {
        titleFilter = item.title.toLowerCase().includes(searchWord.toLowerCase());
      }
      if (item.comment) {
        commentFilter = item.comment
          .toLowerCase()
          .includes(searchWord.toLowerCase());
      }
      if (titleFilter || commentFilter) {
        return {
          ...item,
          filtered: false,
        };
      }
      return { ...item, filtered: true };
    });
    if (searchWord) {
      setLeadsList(leadsListFiltered);
      setSearchToStorage(leadsListFiltered, searchWord);
    } else {
      sessionStorage.setItem('savedValue', '');
      sessionStorage.removeItem('lastSearch');
      setLeadsList(leads.data);
    }
  }

  const needUpdateData = () => {
    // console.log('jkj')
    const parsed = queryString.parse(getQuery());
    setLeadsPerPage(parsed.leadsPerPage || '20');
    const leadsPerPageInner = parsed.leadsPerPage || '20';
    setPage(parseInt(parsed.page, 10) || 1);
    const pageInner = parsed.page ? parseInt(parsed.page, 10) : 1;
    delete parsed.leadsPerPage;
    delete parsed.page;
    delete parsed.offset;
    if (
      funnelStatuses.length !== 0
            && workTech.length !== 0
            && workType.length !== 0
            && funnelType.length !== 0
            && priorities.length !== 0
            && responsible.length !== 0
    ) {
      const objectivePriorities = Object.entries(priorities).map((key) => ({
        id: key[0],
        name: key[1],
      })) || [];
      const objectiveResp = Object.entries(responsible).map((key) => ({
        id: key[0],
        name: key[1],
      })) || [];
      setLeadType(parsed.status || leadType);
      const requestStr = `
		      ${setStateByUrlData(workType, 'workType[]', setWorkTypes) || ''}
		      ${
  setStateByUrlData(
    funnelType,
    'funnelType[]',
    setSelectedFunnelTypes,
  ) || ''
}
		      ${setStateByUrlData(workTech, 'workTech[]', setWorkTechs) || ''}
		      ${
  setStateByUrlData(
    funnelStatuses,
    'funnelStatus[]',
    setSelectedFunnelStatuses,
  ) || ''
}
		      ${
  setStateByUrlData(
    objectiveResp,
    'responsible[]',
    setSelectedResponsible,
  ) || ''
}
		      ${
  setStateByUrlData(
    objectivePriorities,
    'priority[]',
    setSelectedPriorities,
  ) || ''
}
		      ${parsed.status ? `&status=${parsed.status}` : ''}`.replace(/\s/g, '');
      const sortQuery = parsed.order !== undefined ? `&${parsed.sortByUpdated ? 'sortByUpdated' : 'sortByCreated'}=true&order=${parsed.order}` : `&${sortSave.typed}=true&order=${sortSave.order}`;
      // console.log(sortQuery);
      // console.log(requestStr);
      // console.log(pageInner);
      // console.log(leadsPerPageInner);
      props.getLeads(
        `page=${pageInner}&limit=${leadsPerPageInner}${requestStr}${sortQuery}`,
      );
    }
  };

  function renderLeadsList() {
     if (leadsList) {
      return leadsList.map((item) => {
        if (!item.filtered) {
          return <LeadItem key={item.id} data={item} {...props} />;
        }
        return null;
      });
    }
    return null;
  }

  const setFiltersData = (func, data) => {
    func(data);
    setCounter(counter + 1);
  };
    // ===============================================
  const openDiv = () => {
    const itemRef = document.querySelector('#filter__filtering-types');
    const mainItemRef = document.querySelector('#filter-container');
    const imageRef = document.querySelector('#imageRef-filter');
    if (
      itemRef.classList.value.indexOf('filter__filtering-types__opened') === -1
    ) {
      itemRef.classList.add('filter__filtering-types__opened');
      mainItemRef.classList.add('lead__item__additional_info_opened');
      imageRef.style.transform = 'scaleY(-1)';
      mainItemRef.style.borderBottom = '1px solid #ced4da';
    } else {
      imageRef.style.transform = 'scaleY(1)';
      itemRef.classList.remove('filter__filtering-types__opened');
      mainItemRef.style.borderBottom = 'none';
    }
  };

  function buildRequestLink() {
    // console.log(localStorage.getItem('FilterLeads'));
    const priority = buildArrayString('priority[]', selectedPriorities);
    const workTypes = buildArrayString('workType[]', selectedWorkTypes);
    const workTechs = buildArrayString('workTech[]', selectedWorkTechs);
    const funnelTypes = buildArrayString('funnelType[]', selectedFunnelTypes);
    const sortType = buildStringSort(sortSave);
    // console.log(sortType);
    // console.log(sortType)
    const funnelStatus = buildArrayString(
      'funnelStatus[]',
      selectedFunnelStatuses,
    );
    const responsibleData = buildArrayString(
      'responsible[]',
      selectedResponsible,
    );
    return `
  	${priority}
  	${workTypes}
  	${workTechs}
  	${funnelTypes}
  	${funnelStatus}
  	${responsibleData}
  	${sortType}
  	`.replace(/\s/g, '');
  }

  function setFilters(limit, pageInner) {
    // console.log('setFilters');
    let route = buildRequestLink();
    // console.log(route);
    if (parseInt(leadType, 10) !== 2) {
      props.getLeads(
        `${route}&status=${leadType}&page=${pageInner}&limit=${limit}`.substring(
          1,
        ),
      );
      route = `${route}&status=${leadType}`;
    } else {
      props.getLeads(`${route}&page=${pageInner}&limit=${limit}`);
    }
    setLeadsPerPage(limit);
    setPage(pageInner);
    props.setTopOffset(0);
    route = route.substring(1);
    // console.log(route);
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${route}&leadsPerPage=${limit}&page=${pageInner}`;
    if (window.history.pushState) {
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
    // console.log(route);
    setFiltersToStorage(
      'FilterLeads',
      `${route}&leadsPerPage=${limit}&page=${pageInner}`,
    );
    props.setTopOffset(0);
  }

  const renderFiltersList = (data, stateSetter, title) => data.map((item) => (
    <SelectedFilter
      key={`${item.id}-${item.name}`}
      item={item}
      data={data}
      stateSetter={stateSetter}
      title={title}
      setOnRemove={setOnRemove}
    />
  ));

  function clearSavedFilters() {
    setSelectedPriorities([]);
    setWorkTypes([]);
    setWorkTechs([]);
    setSelectedFunnelTypes([]);
    setSelectedFunnelStatuses([]);
    setSelectedResponsible([]);
    setLeadType('2');
    props.getLeads(`page=${page}&limit=${leadsPerPage}`);
    // const [onRemove, setOnRemove] = useState(false);
    setCounter(1);
    clearFiltersData('FilterLeads');
    setSortSave({ typed: 'sortByUpdated', title: 'Time updated: High to Low', order: 'desc' });
  }

  function setOptionForSelect(
    data,
    classForOption = null,
  ) {
    return (
      <>
      <span
        className={classForOption}
        onClick={() => {
          data.updated = true;
          setSortSave(data);
        }}
      >
        {data.title}
        {data.order === 'asc'?  <SortUp style={{margin:'10px'}}/> :  <SortDown style={{margin:'10px'}}/>}

      </span>
      </>
    );
  }

  return (
    <div className="lead__container__list">
      <div className="filter__container--outer">
        <div className="filter">
          <div className="filter-container" id="filter-container">
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {renderFiltersList(
                selectedPriorities,
                setSelectedPriorities,
                'Priorities',
              )}
              {renderFiltersList(selectedWorkTypes, setWorkTypes, 'Work Types')}
              {renderFiltersList(selectedWorkTechs, setWorkTechs, 'Work Tech')}
              {renderFiltersList(
                selectedFunnelTypes,
                setSelectedFunnelTypes,
                'Funnel Types',
              )}
              {renderFiltersList(
                selectedFunnelStatuses,
                setSelectedFunnelStatuses,
                'Funnel Statuses',
              )}
              {renderFiltersList(
                selectedResponsible,
                setSelectedResponsible,
                'Responsible',
              )}
              {parseInt(leadType, 10) !== 2 ? (
                <div key="leadTypeSelected" className="filter-selected">
                  <span>
                    Lead Type:
                    {parseInt(leadType, 10) === 1 ? 'Open' : 'Close'}
                  </span>
                  <button
                    type="button"
                    onClick={() => {
                      setCounter(counter + 1);
                      setLeadType('2');
                      setOnRemove(true);
                    }}
                    className="filter-close"
                  >
                    <Close />
                  </button>
                </div>
              ) : null}
            </div>
            <button
              type="button"
              onClick={() => {
                openDiv();
              }}
              className="filter__open-button lead_item__inner-elements__arrow"
            >
              <DownArrow
                style={{ transition: '.3s' }}
                id="imageRef-filter"
                className="down-arrow"
              />
            </button>
          </div>
          <div className="filter__filtering-types" id="filter__filtering-types">
            <div className="filter__filtration-parameters">
              <div className="filter__filtration-parameters__item">
                <span className="filter__filtration-parameters__item__title">
                  Priority
                </span>
                <Multiselect
                  options={
                                        Object.entries(priorities).map((key) => ({
                                          id: key[0],
                                          name: key[1],
                                        })) || []
                                    }
                  selectedValues={selectedPriorities}
                  onSelect={(event) => {
                    setSelectedPriorities([]);
                    setSelectedPriorities(event);
                    setFiltersData(setSelectedPriorities, event);
                  }}
                  onRemove={(event) => {
                    setFiltersData(setSelectedPriorities, event);
                  }}
                  displayValue="name"
                />
              </div>
              <div className="filter__filtration-parameters__item">
                <span className="filter__filtration-parameters__item__title">
                  Work Types
                </span>
                <Multiselect
                  options={workType}
                  selectedValues={selectedWorkTypes}
                  onSelect={(event) => {
                    setFiltersData(setWorkTypes, event);
                  }}
                  onRemove={(event) => {
                    setFiltersData(setWorkTypes, event);
                  }}
                  displayValue="name"
                />
              </div>
              <div className="filter__filtration-parameters__item">
                <span className="filter__filtration-parameters__item__title">
                  Work Technologies
                </span>
                <Multiselect
                  options={workTech}
                  selectedValues={selectedWorkTechs}
                  onSelect={(event) => {
                    setFiltersData(setWorkTechs, event);
                  }}
                  onRemove={(event) => {
                    setFiltersData(setWorkTechs, event);
                  }}
                  displayValue="name"
                />
              </div>
              <div className="filter__filtration-parameters__item">
                <span className="filter__filtration-parameters__item__title">
                  Funnel Type
                </span>
                <Multiselect
                  options={funnelType}
                  selectedValues={selectedFunnelTypes}
                  onSelect={(event) => {
                    setFiltersData(setSelectedFunnelTypes, event);
                  }}
                  onRemove={(event) => {
                    setFiltersData(setSelectedFunnelTypes, event);
                  }}
                  displayValue="name"
                />
              </div>
              <div className="filter__filtration-parameters__item">
                <span className="filter__filtration-parameters__item__title">
                  Funnel Status
                </span>
                <Multiselect
                  options={funnelStatuses}
                  selectedValues={selectedFunnelStatuses}
                  onSelect={(event) => {
                    setFiltersData(setSelectedFunnelStatuses, event);
                  }}
                  onRemove={(event) => {
                    setFiltersData(setSelectedFunnelStatuses, event);
                  }}
                  displayValue="name"
                />
              </div>
              <div className="filter__filtration-parameters__item">
                <span className="filter__filtration-parameters__item__title">
                  Responsible
                </span>
                <Multiselect
                  options={
                                        Object.entries(responsible).map((key) => ({
                                          id: key[0],
                                          name: key[1],
                                        })) || []
                                    }
                  selectedValues={selectedResponsible}
                  onSelect={(event) => {
                    setFiltersData(setSelectedResponsible, event);
                  }}
                  onRemove={(event) => {
                    setFiltersData(setSelectedResponsible, event);
                  }}
                  displayValue="name"
                />
              </div>
              <div className="filter__filtration-parameters__item">
                <span className="filter__filtration-parameters__item__title">
                  Status Open/Closed 
                </span>
                <Form.Group style={{ width: 250 }} controlId="formGridState">
                  <Form.Control
                    as="select"
                    style={{ fontSize: 14, color: 'rgb(119, 119, 119)' }}
                    value={leadType}
                    onChange={({ target: { value } }) => {
                      setFiltersData(setLeadType, value);
                    }}
                  >
                    <option key={256} value={2}>
                      None
                    </option>
                    <option key={1} value={0}>
                      Closed
                    </option>
                    <option key={2} value={1}>
                      Open
                    </option>
                  </Form.Control>
                </Form.Group>
              </div>
            </div>
            <div
              style={{
                marginBottom: 15,
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                style={{ marginRight: 20 }}
                onClick={() => {
                  clearSavedFilters();
                }}
                size="sm"
              >
                Clear saved filters
              </Button>
              <Form inline>
                <FormControl
                  type="text"
                  onChange={({ target: { value } }) => {
                    filterLeads(value);
                  }}
                  value={sessionStorage.getItem('savedValue')}
                  placeholder="Search subject or descr."
                  className=" mr-sm-2"
                />
              </Form>
              <Button
                onClick={() => {
                  setFilters(leadsPerPage, 1);
                  openDiv();
                }}
                size="sm"
                id="apply-filter"
              >
                Apply
              </Button>
            </div>
          </div>
        </div>
        <div
          className="custom-select-wrapper"
          onClick={() => setIsDropdownListOpen(!isDropdownListOpen)}
        >
          <div
            className={
                            `custom-select-container${isDropdownListOpen ? ' open' : ''}`
                        }
          >
            <div className="custom-select__trigger">
              <div>
                <span>{sortSave.title}</span>
                {sortSave.order === 'asc'?  <SortUp style={{margin:'10px'}}/> :  <SortDown style={{margin:'10px'}}/>}
              </div>
              <DownArrow
                style={{
                  transition: '.3s',
                  transform: isDropdownListOpen ? 'scaleY(-1)' : 'scaleY(1)',
                }}
                id="imageRef-filter1"
                className="down-arrow"
              />
            </div>
            <div className="custom-options">
              {setSortOptions.map((item) => (
                setOptionForSelect(
                  item,
                  'custom-option',
                )
              ))}

            </div>
          </div>
        </div>
      </div>
      {renderLeadsList()}
      <Paginator
        itemsPerPage={leadsPerPage}
        activePage={page}
        totalItemsCount={leads.total}
        setFilters={setFilters}
      />
      <div />
      <FolderAndEstimationPopup needUpdateData={needUpdateData} {...props} />
      <RedminePopup {...props} />
    </div>
  );
};
export default connect(
  (state) => ({
    leads: state.leadReducer.leads,
    leadsFromRedminePopup: state.leadReducer.leadsFromRedminePopup,
    savedSearch: state.leadReducer.savedSearch,
    priorities: state.skillsReducer.priorities,
    funnelStatuses: state.leadReducer.funnelStatuses,
    funnelType: state.leadReducer.funnelType,
    workType: state.leadReducer.workType,
    workTech: state.leadReducer.workTech,
    responsible: state.leadReducer.responsible,
    offset: state.leadReducer.offset,
  }),
  {
    getLeads,
    getAccountOwnersList,
    setTopOffset,
    addSearchLeads,
  },
)(LeadsList);
